import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';

declare const NetPay: any;

@Component({
  selector: 'app-list-packages',
  templateUrl: './list-packages.component.html',
  styleUrls: ['./list-packages.component.scss'],
})
export class ListPackagesComponent implements OnInit {
  @ViewChild('modalPackage', { static: false }) modalPackage!: TemplateRef<any>;
  @ViewChild('modalStandBy', { static: false }) modalStandBy!: TemplateRef<any>;
  modalPackageClose: any;
  private deviceFingerPrint: string | null = null;

  activePackage: any = FormGroup;
  messageError: string = '';
  submitForm: boolean = false;
  filterText: string = '';
  packages: any[] = [];
  standBy: any[] = [];
  filterPackages: any = [];
  breadcrumbs: any;
  rolename: any = '';
  rolekey: any = '';
  idDeleted: number = 0;
  packageNameDeleted: string = '';
  flagDeleted: boolean = false;
  message: string = '';
  offices: any = [];
  roleofficeid: number = 0;
  currentOfficeId: number = 0;
  confirmDelete: boolean = false;
  flagError: boolean = false;
  standByPackageId: Number = 0;
  clientName: string = '';
  minimalAmount: string = '';
  standById: Number = 0;
  // cambios paginacion
  totalPages: number = 0; 
  limit: number = 25;
  totalItems: number = 0;
  page: number = 1;
  nextLabel = 'Siguiente';
  previousLabel = 'Anterior';
  errorMessage: string = '';

  constructor(
    private api: ApiService,
    private modal: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private printService: PrintService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.breadcrumbs = [
      { name: 'Agenda', path: '/dashboard/new-calendar', link: true },
      { name: 'Lista de paquetes', link: false },
    ];
    const savedPage = this.route.snapshot.queryParamMap.get('page');
    this.page = savedPage ? +savedPage : 1;

    this.loadPackages(this.page); 
    this.roleInfo();
    this.getOffices();
    this.validations();
  }

  validations(): void {
    this.activePackage = this.fb.group({
      packageId: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      minimalPaid: ['', [Validators.required]],
      standById: ['', [Validators.required]]
    });
  }

  reloadInfo() {
    this.loadPackages(this.page); 
    this.roleInfo();
    this.getOffices();
  }

  roleInfo() {
    this.api.get('employees/roles').subscribe({
      next: (roles) => {
        this.rolename = roles.user.role;
        this.rolekey = roles.user.key.toLowerCase();
        this.roleofficeid = roles.user.office.id;
        this.currentOfficeId = this.roleofficeid;
      },
      error: (err) => {},
    });
  }

  loadPackages(page: number = 1) {
    this.page = page;
    this.api.get(`packages/${this.currentOfficeId}?page=${page}&limit=${this.limit}`)
      .subscribe((res: any) => {
        this.packages = res.packages;
        this.standBy = res.standBy;
        this.filterPackages = this.packages;
        this.totalItems = res.total;
        this.totalPages = Math.ceil(this.totalItems / this.limit);
      });
  }
  
  deletePackages(id: number): void {
    this.api.delete('packages/delete', Number(id)).subscribe({
      next: (packages) => {
        this.message = packages.message;
        const id = packages.packages.id;
        this.flagDeleted = true;

        this.filterPackages = this.filterPackages.filter(
          (packageData: any) => Number(packageData.id) !== Number(id)
        );
        this.modalPackageClose.close();
      },
      error: (err) => {},
    });

    setTimeout(() => {
      this.flagDeleted = false;
      this.message = '';
    }, 4000);
  }

  confirmDeletePackages(flag: boolean) {
    if (flag === false) {
      this.close();
    }

    this.confirmDelete = flag;
  }

  getOffices() {
    this.api.get('offices').subscribe({
      next: (offices) => {
        this.offices = offices.offices;
      },
      error: (err) => {},
    });
  }

  setCurrentOffice(evt: any) {
    this.api.get(`packages/${evt.target.value}`).subscribe({
      next: (packages) => {
        this.packages = packages.packages;
        this.filterPackages = this.packages;
      },
      error: (err) => {},
    });
  }

  clearSearch() {
    this.filterText = '';
    this.currentOfficeId = this.roleofficeid;
    this.loadPackages();
  }

  openDeleteMessage(id: number, packagename: string): void {
    this.idDeleted = id;
    this.packageNameDeleted = packagename;

    this.modalPackageClose = this.modal.open(this.modalPackage, { size: 'md' });
  }

  close(): void {
    this.modalPackageClose.close();
  }

  matches(listData: any, term: string) {
    return (
      listData.client.name.toLowerCase().includes(term.toLowerCase()) ||
      listData.client.office.toLowerCase().includes(term.toLowerCase()) ||
      listData.price.includes(term) ||
      listData.duration.includes(term) ||
      listData.date_purchased.includes(term)
    );
  }

  filterRecords() {
    const filterData = this.packages.filter((data: any) => {
      return this.matches(data, this.filterText);
    });

    this.filterPackages = filterData;
    this.page = 1;
  }

  onPageChange(page: number) {
 this.page = page;
  this.loadPackages(page);

  this.router.navigate([], {
    relativeTo: this.route,
    queryParams: { page: this.page },
    queryParamsHandling: 'merge'
  });
  }

  printTicketAgain(printTicket: any): void {
    console.log('PRINT BUTTON CLICKED', printTicket);
    console.log('1. Button clicked');
    console.log('2. Print ticket:', printTicket);
    console.log('3. State code:', printTicket?.state_code);
    console.log('4. API service:', this.api);


    if (printTicket.state_code == 'Bc') {
      console.log('5. Calling Peninsula method');
      this.api.onPrintRecipientPeninsula(printTicket);
    } else {
      console.log('5. Calling standard receipt method');

    console.log(
      '6. Method exists:',
      typeof this.api.onPrintRecipient
    );
      this.api.onPrintRecipient(printTicket);
    }
  }

  openToRegularPackage(packageId: Number, name: string, minimal: string, standById: Number): void {
    this.standByPackageId = packageId;
    this.clientName = name;
    this.minimalAmount = minimal;
    this.standById = standById;

    this.activePackage.patchValue({
      packageId: packageId,
      minimalPaid: minimal,
      standById: this.standById,
      amount: ''
    });

    this.modalPackageClose = this.modal.open(this.modalStandBy, { size: 'lg' });
  }

  saveMoneyActivatePackage(): void {
    this.submitForm = true;

    if (this.activePackage.invalid) {
      this.messageError = 'Por favor, ingrese una cantidad valida!';
      this.submitForm = false;
      return;
    }

    const obj = {
      packageId: this.activePackage.value.packageId,
      amount: this.activePackage.value.amount,
      minimalPaid: this.activePackage.value.minimalPaid,
      standById: this.activePackage.value.standById,
    };

    this.api.update('packages/moveToRegular', this.activePackage.value.packageId, obj).subscribe({
      next: (data) => {
        if (data.flagError) {
          this.messageError = `${data.message} La cantidad minima es ${data.minimal}, la cantidad que se intento pagar fue ${data.amount}`;
          this.flagError = true;
          this.modalPackageClose.close();

          setTimeout(() => {
            this.flagError = false;
            this.messageError = '';
          }, 4000);
        } else {
          this.message = data.message;
          this.flagDeleted = true;
          this.reloadInfo();
          this.modalPackageClose.close();

          setTimeout(() => {
            this.flagDeleted = false;
            this.message = '';
          }, 4000);
        }
      }
    });
  }

  //Metodo para visibilizar un máximo de 4 páginas en la paginación
  getVisiblePages(): number[] {
    const max = 4;

    let start = this.page;
    let end = this.page + max - 1;

    if (end > this.totalPages) {
      end = this.totalPages;
      start = end - max + 1;
    }

    if (start < 1) start = 1;

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }

  // modal to open the automatic charge
  openNetPayModal(netPayContent: TemplateRef<any>): void {
    this.errorMessage = '';

    const modalRef = this.modal.open(netPayContent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });

    /* setTimeout(() => {
      this.initializeNetPay();
    }, 200); */
    modalRef.shown.subscribe(() => {
      this.initializeNetPay();
    });

    modalRef.result.then(
      () => {
        console.log('Modal closed');
      },
      () => {
        console.log('Modal dismissed');
      }
    );
  }

  private initializeNetPay(): void {
    if (typeof NetPay === 'undefined') {
      this.errorMessage = 'NetPay SDK could not be loaded.';
      return;
    }

    try {
      // Clear previous form if the modal was opened before
      const container = document.getElementById('netpay-form');
      if (container) {
        container.innerHTML = '';
      }

      let deviceFingerPrint = '';
      NetPay.setApiKey('pk_netpay_JGFtQNUFIENMlhkoBXdgiozmQ');
      NetPay.setSandboxMode(true);


      NetPay.form.generate(
        'netpay-form',
        (response: any) => {
          console.log('Token created successfully:', response);
          /*
           * IMPORTANT:
           * Send the token to your Symfony backend.
           * Do not send card information directly.
           */

          // Example:
          // this.paymentService.processPayment(response).subscribe(...);
        },
        (error: any) => {
          console.error('NetPay error:', error);
          this.errorMessage = 'Something went wrong processing the card.';
        },
        {
          title: 'Domiciliar Pago',
          submitText: 'Confirmar Pago'
        }
      );
    } catch (error) {
      console.error('NetPay initialization error:', error);

      this.errorMessage = 'Unable to initialize the payment form.';
    }
  }
}
